import React from 'react';

import Heading from 'grommet/components/Heading';
import Paragraph from 'grommet/components/Paragraph';

export default () => (
  <>
    <Heading>Site Terms</Heading>
    <Paragraph>Last Updated: May 2018</Paragraph>
    <Paragraph>© Encore Estate Management. 2018. All rights reserved.</Paragraph>

    <Heading tag="h3">Introduction</Heading>
    <Paragraph>
      This is the official website of Encore Estate Management. Our website is intended to provide free information
      about Encore Estate Management. By using this website you are accepting the following terms and conditions -
      please read them carefully. If you do not wish to accept these terms and conditions, we suggest that you do not
      use this site. Encore reserves the right to amend content of this website at any time.
    </Paragraph>

    <Heading tag="h3">Accessing our website</Heading>
    <Paragraph>
      Whilst we have taken every care in the preparation of the content of our site, we cannot guarantee uninterrupted
      and totally reliable access to it. We cannot therefore guarantee that the information will always be up to date
      and free of errors. We accept no responsibility for your inability to access our site arising out of circumstances
      beyond our reasonable control, as access to our website is dependent upon the availability of the worldwide web.
      From time to time, our site may contain links to and from third party websites. If you follow a link, please note
      that these sites have their own privacy policies and will be subject to separate terms and conditions and we do
      not accept responsibility or liability for these sites.
    </Paragraph>

    <Paragraph>Unauthorised use of our website</Paragraph>

    <Paragraph>Submit any information that is obscene, threatening, hateful or abusive</Paragraph>

    <Paragraph>
      Enter any but not limited to; cgi scripts, images, html code or any other part of this site is strictly prohibited
    </Paragraph>

    <Paragraph>
      Prohibited from interfering with the site service including flooding, mailing, hacking, crashing or amending site
      content
    </Paragraph>

    <Paragraph>
      Do not direct or redirect our web site and related material through any unsolicited emails to this site
    </Paragraph>

    <Heading tag="h3">Warranty Disclaimer</Heading>

    <Paragraph>
      All information and images contained on this website are believed to be truthful and accurate. Commentary and
      other materials posted on our website are provided for general information purposes only and are not intended to
      be relied upon by you, unless confirmed by Encore in writing. We do not warrant, guarantee or represent that
      material downloaded and/or accessed via or from our website will be free of viruses and you should operate the
      most up-to-date virus protection software at all times.
    </Paragraph>

    <Heading tag="h3">Copyright</Heading>

    <Paragraph>
      Work originated by us from graphics, images, logos, and data to html code belongs to Encore. Reproduction,
      adaptation or modification of all or any part of these contents are strictly prohibited without written permission
      of Encore. All materials published are owned by, or are licensed to us.
    </Paragraph>

    <Heading tag="h3">Privacy</Heading>

    <Paragraph>
      We may collect information about you when you request any information about us or our services, or submit your
      personal details and/or complete any forms on this website. Any information or data which you may provide to
      Encore at any time will be treated as confidential and will not be traded, sold, or rented to a third party but
      all information is provided at your own risk as we cannot ensure the security of your data transmitted to our
      site. This information may include contact details, completing application forms for job vacancies or requesting
      further information about our services. This information will only be disclosed as may be required by English law.
    </Paragraph>

    <Paragraph>Please refer to our Privacy Notice for more information.</Paragraph>

    <Heading tag="h3">Cookies</Heading>
    <Heading tag="h4">What are Cookies</Heading>
    <Paragraph>
      Cookies are small files of letters and numbers. These files are stored on the hard drive of the device you are
      using, be it a PC, mobile phone, or tablet. These letters and numbers are used to allow a website to remember
      certain bits of information, so that the user experience can be improved next time you visit.
    </Paragraph>

    <Paragraph>By using our website you agree that we may store and access cookies on your device.</Paragraph>

    <Heading tag="h4">How we use Cookies</Heading>

    <Paragraph>
      When you visit our website it is likely we will create cookies which are stored on your device. For the duration
      of your 'session' on our website these cookies help us to deliver the correct information and ensure you only have
      to enter required information once, thereby improving your browsing experience.
    </Paragraph>

    <Paragraph>
      We also use web analytics to understand how many people have visited our website, what they have looked at and how
      they found us etc. This gives us a better understanding of how our website is working. All data accrued cannot be
      used to identify personal information and merely gives us a general idea of how our website performs.
    </Paragraph>

    <Paragraph>
      This overview of the type of cookies we use is based on categories outlined by the International Chamber of
      Commerce, in the ICC UK Cookie Guide. Some cookies may appear in multiple categories.
    </Paragraph>

    <Paragraph>Category 1: strictly necessary cookies</Paragraph>

    <Paragraph>
      These cookies are necessary for the website to function. By disabling these cookies, some aspects of a website
      will either not work, or not work properly, such as secure logins, location services, and e-commerce
      functionality.
    </Paragraph>

    <Paragraph>
      This cookie is used to distinguish between humans and bots. This is beneficial for the website, in order to make
      valid reports on the use of their website.
    </Paragraph>

    <Paragraph>Category 2: performance cookies</Paragraph>

    <Paragraph>
      These cookies gather information to help improve the day to day performance of a website. By analysing data
      collected we can enhance popular pages, fix bugs and error messages etc. All data is based on totals and averages
      and is strictly anonymous.
    </Paragraph>

    <Paragraph>
      For example we use Google Analytics, which creates several first-party cookies. The data that Google collects is
      kept strictly private and confidential and won't be shared with anyone else. We don't feel that Google Analytics
      is a breach of privacy as we are merely aggregating the data survey. The information that is collected is used to
      understand website trends and performance.
    </Paragraph>

    <Paragraph>Category 3: functionality cookies</Paragraph>

    <Paragraph>
      These are cookies which provide a 'memory' for the website, this enables the website to remember any personal
      choices you make (for example, your username, language or geographic location). A website may provide local
      weather reports, traffic updates and other similar localised information. These cookies are also used to remember
      changes you may make to text sizes, fonts and other customisable elements of the website. The information these
      cookies collect may be made anonymous and can't track activity on other websites.
    </Paragraph>

    <Paragraph>Category 4: targeting cookies or advertising cookies</Paragraph>

    <Paragraph>
      We nurture the use of social media websites and believe sharing is a key part of how people access new
      information. Social media networks are a popular way of doing this. To enable people to share information via
      popular social media, our website may have functionality allowing this type of activity.
    </Paragraph>

    <Paragraph>
      The owners of social media websites may place cookies on users' devices and they will have their own cookie
      policies. We have no control over these companies' cookies policies.
    </Paragraph>

    <Heading tag="h4">How to turn off cookies</Heading>

    <Paragraph>
      Browsers allow you to change your cookie settings. These links may be helpful in helping you update your browser
      cookie settings if you wish to update them:
    </Paragraph>

    <Paragraph>Cookie settings in Internet Explorer</Paragraph>

    <Paragraph>Cookie settings in Firefox</Paragraph>
    <Paragraph>Cookie settings in Chrome</Paragraph>
    <Paragraph>Cookie settings in Safari</Paragraph>

    <Heading tag="h3">Useful links</Heading>
    <Paragraph>
      To learn more about your rights to online privacy, please visit Data Protection Act 1998 and The Information
      Commissioner's Office.
    </Paragraph>

    <Paragraph>
      The Adobe website provides comprehensive information on how to delete or disable Flash cookies - see
      http://www.adobe.com/products/flashplayer/security for details.
    </Paragraph>

    <Paragraph>
      Find out how to disable cookies by clicking on the "Manage Cookies" section of the Interactive Advertising Bureau
      website on the following link allaboutcookies.org
    </Paragraph>

    <Paragraph>
      Full details of the cookies which Google Analytics uses can be found in Cookies & Google Analytics in
      documentation for Google's Analytics tracking code. You can also read Google's Privacy Policy for Google
      Analytics.
    </Paragraph>

    <Heading tag="h3">Law</Heading>

    <Paragraph>
      These Terms and Conditions and all other express terms herein contained shall be governed and construed in
      accordance with the laws of England.
    </Paragraph>

    <Heading tag="h3">Your concerns</Heading>

    <Paragraph>
      If you have any questions about material which appears on our website please contact: info@encoreestates.co.uk or
      01223 866980.
    </Paragraph>

    {/* <Heading tag="h3">5. DISCLAIMER</Heading>
    <ol>
      <li>
        While we endeavour to ensure that the Content is correct and up-to-date, it is provided “as is” and we give no
        representation, warranty or guarantee as to its accuracy, completeness or adequacy. Accordingly, to the maximum
        extent permitted by law, we exclude all express and implied warranties, representations and conditions with
        respect to the Content.
      </li>
      <li>
        The Website may from time to time contain links to third party websites which we provide solely for your
        convenience. We have no control over, and make no endorsement of, the content or availability of these third
        party websites and you use and rely on the same at your own risk.
      </li>
      <li>
        You acknowledge and agree that any reliance you place on the Content and the content of any linked third party
        sites is at your own risk. To the maximum extent permitted by law, we (and our group companies) exclude all
        liability for any direct or indirect losses, loss of profits or other consequential loss, damages, costs,
        expenses or liabilities that you may suffer or incur arising from your use of this Website and/or reliance on
        any Content.
      </li>
    </ol> */}
  </>
);
